import LegalLayout from "./LegalLayout";

const CONTACT_EMAIL = "privacy@joint.photos";

export default function PrivacyPolicyPage() {
  return (
    <LegalLayout title="Privacy Policy" updatedAt="2026-02-03">
      <p>
        joint.photos (“we”, “us”) is a photo sharing app. This Privacy Policy explains what information we collect, why
        we collect it, and your choices—especially when you sign in with Facebook.
      </p>

      <section>
        <h2 className="text-lg font-semibold">Information we collect</h2>
        <ul className="mt-3 list-disc pl-6 space-y-2">
          <li>
            <span className="font-medium">Account & login information</span>: your email address (for sign-in and
            account identification), and authentication identifiers (e.g. a provider user ID).
          </li>
          <li>
            <span className="font-medium">Facebook Login data</span>: if you choose “Continue with Facebook”, Facebook
            may provide your public profile information (such as your name and Facebook user ID) and your email address.
            We do not request any additional Facebook permissions beyond what is needed to sign you in.
          </li>
          <li>
            <span className="font-medium">Content you provide</span>: photos/videos you upload and related metadata you
            include in the app (for example, album association and timestamps).
          </li>
          <li>
            <span className="font-medium">Technical & security data</span>: basic logs needed to operate and secure the
            service (for example, IP address, user agent, and timestamps of requests).
          </li>
          <li>
            <span className="font-medium">Cookies</span>: we use cookies to keep you signed in (session management).
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-lg font-semibold">How we use information</h2>
        <ul className="mt-3 list-disc pl-6 space-y-2">
          <li>To authenticate you and maintain your session.</li>
          <li>To provide the app’s core features (sharing and viewing albums, uploading media).</li>
          <li>To prevent abuse and keep the service secure.</li>
          <li>To respond to support requests and enforce our policies.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-lg font-semibold">What we don’t do</h2>
        <ul className="mt-3 list-disc pl-6 space-y-2">
          <li>We do not sell your personal information.</li>
          <li>We do not post to Facebook on your behalf.</li>
          <li>We do not access your friends list, posts, or other Facebook data beyond basic login information.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Sharing</h2>
        <p className="mt-3">
          We share information only as needed to run the service (for example, with hosting and infrastructure
          providers). We may also disclose information if required by law or to protect the security of the service and
          our users.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Retention</h2>
        <p className="mt-3">
          We keep your account information and uploaded content for as long as your account is active or as needed to
          provide the service. We may retain limited logs for security and abuse prevention.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Your choices & data deletion</h2>
        <p className="mt-3">
          You can request access to or deletion of your account data by contacting{" "}
          <a className="underline hover:text-white" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
          . See our “Data Deletion” page for instructions.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Contact</h2>
        <p className="mt-3">
          Questions about this policy:{" "}
          <a className="underline hover:text-white" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </section>
    </LegalLayout>
  );
}

